<template>
  <div>
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>

    <div class="item-info">
      <ul class="item-ul">
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">SKU：</span>{{ list.skuCode }}</span
            >
          </div>
          <div class="item-right">
            <span
              ><span style="color: #000">原SKU：</span
              >{{ list.originalSKU }}</span
            >
          </div>
        </li>
        <li class="item-li">
          <p style="margin: 5px 0">
            SKU产品名称：<span style="color: #3d5064">{{
              list.productNameCN
            }}</span>
          </p>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">规格型号：</span>{{ list.model }}</span
            >
          </div>
          <div class="item-right">
            <span><span style="color: #000">品牌：</span>{{ list.brand }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">FNSKU：</span>{{ list.fnsku }}</span
            >
          </div>
          <div class="item-right">
            <span
              ><span style="color: #000">shipmentid：</span
              >{{ list.shipmentID }}</span
            >
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">采购单：</span
              >{{ list.relationNumber }}</span
            >
          </div>
          <div class="item-right"></div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">总库存：</span
              >{{ list.actualQty }}</span
            >
          </div>
          <div class="item-right">
            <span
              ><span style="color: #000">调拨数量：</span
              >{{ list.quantity }}</span
            >
          </div>
        </li>
      </ul>
    </div>

    <div class="search-box">
      <!-- style="background-color:red;border-color:red;color:#fff;" -->
      <van-field
        size="small"
        v-model="scanLocationCode"
        placeholder="请扫描库位"
        right-icon="scan"
        clear-trigger="always"
        clearable
        @click-right-icon="scanSku"
        @keyup.13="getLocation()"
        @input="triggerSearch"
        @keyup="inputNum"
        ref="scanInp"
      />

      <button class="hidden" ref="searchBtn" @click="getLocation()"></button>
      <span style="font-size: 14px; color: red" v-if="showErrStr.length">{{
        showErrStr
      }}</span>
      <span style="font-size: 14px; color: green" v-if="successStr.length">{{
        successStr
      }}</span>
    </div>

    <div class="list">
      <van-row type="flex" justify="center" align="center">
        <van-col span="6">库位</van-col>
        <van-col span="6">库存数</van-col>
        <van-col span="6" style="position: relative"
          >已下架数
          <p
            v-if="list.outQty"
            style="
              position: absolute;
              top: 0px;
              left: 50%;
              font-size: 13px;
              transform: translate(-50%);
            "
          >
            ({{ list.outQty || 0 }})
          </p></van-col
        >
        <van-col span="6">下架数</van-col>
      </van-row>
      <div>
        <van-swipe-cell
          v-for="(item, index) in list.skuStorageList"
          :key="index"
        >
          <div class="list-div" @click="openModel(item.locationCode)">
            <p>{{ item.locationCode }}</p>
            <p>{{ item.totalQty }}</p>
            <p>{{ item.outQty || 0 }}</p>
            <p v-if="item.totalQty > 0">
              <input
                type="number"
                class="downInp"
                readonly
                v-model="item.newOutQty"
              />
            </p>
            <p v-if="item.totalQty <= 0"></p>
          </div>
          <template #right>
            <van-button
              square
              type="danger"
              text="清零"
              @click="toDelete(index)"
            />
          </template>
        </van-swipe-cell>
      </div>

      <div class="submit-box">
        <div class="search-box">
          <van-field
            border
            clickable
            :readonly="isReadonly"
            size="small"
            placeholder="请选择待出库仓库"
            @click="showPicker = true"
            @focus="isReadonly = true"
            @blur="isReadonly = false"
            v-model="list.waitOutWarehouse"
            is-link
            arrow-direction="down"
            clearable
            clear-trigger="always"
          />
        </div>
        <button class="submit-btn" @click="submit">提交</button>
      </div>
    </div>

    <van-popup
      v-model="showPicker"
      round
      position="bottom"
      @close="pickerClose"
    >
      <van-picker
        show-toolbar
        cancel-button-text="关闭"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        @change="onItemChange"
        ref="departmentPicker"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup>

    <van-dialog
      v-model="show"
      :title="`库位 ${saveLocationCode}`"
      show-cancel-button
      confirmButtonText="确认"
      cancelButtonText="取消"
      @confirm="confirm"
    >
      <div style="padding: 5% 20%">
        <van-field
          type="digit"
          size="small"
          placeholder="请输入SKU数量"
          v-model="saveNum"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  SwipeCell,
  Col,
  Row,
  Button,
  Cell,
  Dialog,
} from "vant";
import {
  getPickQuerySkuStorage,
  ConfirmOffShelf,
  CheckStorageAndStock,
  GetWaitOutWarehouseList
} from "@/api/mobile/picking_api";
import { mixins } from "../mobileMixins";
import { mapMutations } from "vuex";
import {debounce} from "util/util";
export default {
  data() {
    return {
      list: {waitOutWarehouse:''},
      scanLocationCode: "",
      show: false,
      saveLocationCode: "",
      saveNum: "",
      showErrStr: "",
      isAutoOpen: false,
      successStr: "",
      showPicker: false,
      isReadonly: false,
      columns: [],
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [SwipeCell.name]: SwipeCell,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
  },
  mixins: [mixins],
  created() {
    this.init();
  },
  mounted() {
    // document.querySelector('.van-field__right-icon').style.color = '#ffffff'
    // document.querySelector('.van-field__control').style.color = '#ffffff'
  },
  methods: {
    ...mapMutations({
      saveMobileTitle: "saveMobileTitle",
    }),

    init() {
      this.saveMobileTitle(window.localStorage.mobileTitle);
      this.getList();
	   this.GetWaitOutWarehouseList();
    },

    triggerSearch() {
      this.$refs.searchBtn.click();
    },

    onConfirm(val) {
      this.$set(this.list, "waitOutWarehouse", val);
      this.showPicker = false;
    },
    onItemChange(e, value, index) {
      function fn() {
        const that = this;
        this.$set(this.list, "waitOutWarehouse", value);
        that.showPicker = false;
      }
      debounce(fn.apply(this), 300);
    },

    pickerClose() {
      this.$refs.departmentPicker.confirm();
    },

    GetWaitOutWarehouseList() {

 const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;
      const warehouseID = _warehouse.warehouseId;
      GetWaitOutWarehouseList({warehouseId:warehouseID}).then((res) => {
        if (res.status === 200) {
          const { response } = res;
          let arr = [];
          response.forEach((item) => {
            arr.push(item.locationCode);
          });
          this.columns = arr;
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    getList() {
      const that = this;

      const {
        shippingPlanDetailID,
        shippingPlanID,
        skuCode,
        productID,
        stockingTaskID,
      } = this.$route.query;

      const data = {
        shippingPlanDetailID,
        shippingPlanID,
        skuCode,
        productID,
        stockingTaskID,
      };

      getPickQuerySkuStorage(data).then((res) => {
        if (res.status === 200) {
          const { response } = res;

          this.list = response;

          if (!response.productID) {
            Toast.clear();
            Toast("已拣货完成，待打包");

            setTimeout(function () {
              that.$router.go(-1);
            }, 1500);
          }
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    openModel(code) {
      this.show = !this.show;
      this.saveLocationCode = code;
      this.isAutoOpen = false;
      this.successStr = "";
    },

    confirm() {
      this.list.skuStorageList.forEach((item, i) => {
        if (item.locationCode === this.saveLocationCode) {
          if (!item.outQty) {
            if (this.saveNum > item.totalQty) {
              this.saveNum = item.totalQty;
            } else if (this.saveNum < 0) {
              this.saveNum = 0;
            }
          } else {
             if (this.saveNum <= item.outQty) {
              Toast("不可小于该库位已下架数量");
              this.saveNum = 0;
            }
          }
          this.$set(
            this.list.skuStorageList[i],
            "newOutQty",
            this.saveNum || 0
          );
        }
      });
      const s = this.saveNum;
      if (this.isAutoOpen) {
        this.showErrStr = "";
        this.successStr = `库位 ${this.saveLocationCode} 扫入成功，数量${s}`;
      }

      this.saveNum = "";
    },

    toDelete(i) {
      this.$set(this.list.skuStorageList[i], "newOutQty", 0);
    },
    showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;
      const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;
      const warehouseID = _warehouse.warehouseId;

      let data = [];
      let obj = {};
	  
	  if(this.list.waitOutWarehouse==''||this.list.waitOutWarehouse==null||this.list.waitOutWarehouse=='undefined'){
         this.showsound(false);
         Toast.fail('请选择待出库仓位');
		     return;
	  }
      console.log(this.list.skuStorageList);
      console.log(this.list);
      this.list.skuStorageList.forEach((item, index) => {
        if (item.newOutQty) {
          const {
            storageID,
            locationCode,
            skuCode,
            productID,
            stockingTaskID,
            shippingPlanDetailID,
            newOutQty,
            totalQty,
            stockingPickDetailID,
            inventoryBatchOccupyID,
          } = item;
          const { shippingPlanID, outQty } = this.list;

          obj = {
            storageId: storageID,
            stockingtaskid: stockingTaskID,
            shippingplanid: shippingPlanID,
            shippingplandetailid: shippingPlanDetailID,
            inventoryBatchOccupyID:inventoryBatchOccupyID,
            locationCode,
            warehouseID,
            skuCode,
            productID,
            outQty,
            newOutQty,
            totalQty,
            stockingPickDetailID,
			      WaitOutWarehouse:this.list.waitOutWarehouse
          };
          data.push(obj);
        }
      });

      Toast.loading({
        message: "下架中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      ConfirmOffShelf(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          this.successStr = "";
          this.showErrStr = "";
          Toast.success(res.msg);
          this.getList();
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },

    scanSku() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.scanLocationCode = a.resultStr;
          that.getLocation();
        },
      });
    },

    getLocation() {
      this.showErrStr = "";
      this.successStr = "";

      const data = {
        locationCode: this.scanLocationCode,
        productId: this.list.productID,
        ShippingPlanDetailID: this.list.shippingPlanDetailID,
        StockingTaskID: this.list.stockingTaskID,
        ShippingPlanID: this.list.shippingPlanID,
      };

      CheckStorageAndStock(data).then((res) => {
        if (res.status === 200 && res.success) {
          this.showErrStr = "";

          if (res.response.length === 1) {
            this.show = true;
            this.isAutoOpen = true;
            this.saveLocationCode = res.response[0].locationCode;
            this.$set(this.list, "skuStorageList", res.response);
          } else {
            this.$set(this.list, "skuStorageList", res.response);
          }
        } else {
          this.showErrStr = res.msg;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;
  .item-ul {
    .item-li {
      display: flex;
      align-content: flex-start;
      & > div {
        white-space: nowrap;
        word-break: break-all;
        flex: 1;
        line-height: 25px;
        & > span {
          vertical-align: text-top;
          &:first-child {
            padding-right: 10px;
            width: 50%;
            display: inline-block;
          }
          &:last-child {
            color: #3d5064;
          }
        }
        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}
.submit-box {
  position: static;
  margin: 20px 0;
}
.submit-btn {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
  position: static;
  bottom: 2%;
}
.hidden {
  display: none;
}
.addInfo {
  position: absolute;
  right: 1%;
  color: #027db4;
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  padding-left: 10px;
}
.search-box {
  text-align: center;
  padding: 3% 12% 1.5%;
}
::v-deep .van-col {
  text-align: center;
  background-color: #f2f2f2;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}
.list {
  .list-div {
    display: flex;
    height: 43px;
    line-height: 43px;
    border-bottom: 1px solid #ccc;
    & > p {
      flex: 1;
      text-align: center;
      margin: 0;
      & > .downInp {
        width: 55%;
        border: 1px solid #ccc;
        height: 25px;
        line-height: 25px;
        text-align: center;
      }
    }
  }
}
.sign-photo-save {
  padding: 0 10px;
}
.photo {
  font-size: 14px;
}
</style>